import React from "react";
import { Link } from "react-router-dom";
import { Table, Space, Button, Tag } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { ListComponent, BaseListComponentProps } from "../BaseComponent";
import { SearchRequest } from "../../services/api/interfaces/ApiRequest";
import { SearchOptions } from "../TableHelper";
import { Pagination } from "components/Pagination";

type MappingBreedListProps = BaseListComponentProps & {
  loading: boolean;
  mappingBreeds: any;
  pagination: any;
  filters: any | null;
  history?: any;

  loadMappingBreeds: (args: SearchRequest) => Promise<any>;

  onLoad?: (searchOptions: SearchOptions) => void;
};

export default class MappingBreedList extends ListComponent<MappingBreedListProps> {
  static defaultProps = {
    loading: false,
    mappingAges: [],

    loadMappingBreeds: () => {},
  };

  tableColumns = [
    {
      title: "Partner",
      dataIndex: "partner_key",
      key: "partner_key",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.partner_key - b.name,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a: any, b: any) => a.name - b.name,
    },
    {
      title: "External ID",
      dataIndex: "external_id",
      key: "external_id",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.external_id - b.external_id,
    },
    {
      title: "Breed",
      dataIndex: ["breed", "name"],
      key: "breed_id",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.breed?.name - b.breed?.name,
    },
    {
      title: "Specie",
      dataIndex: ["specie", "name"],
      key: "specie_id",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.specie?.name - b.specie?.name,
    },
    {
      title: 'Shelter',
      dataIndex: ['shelter', 'name'],
      key: 'shelter_id',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.shelter?.name - b.shelter?.name,
      render: (value: any, record: any, index: number) => record.shelter_id ? value : <Tag children="GLOBAL" />
    },
    {
      title: "Actions",
      key: "action",
      render: (text: string, record: any) => (
        <Space size="middle">
          <Link
            to={`breed/${record.uuid}`}
            ref={(refs) => this.actionRefs.edit.push(refs)}
          >
            <Button type="dashed" shape="round" icon={<EditOutlined />} />
          </Link>
        </Space>
      ),
    },
  ];

  componentDidUpdate(prevProps: any, prevState: any) {
    this.validateAccessPermissions();

    if (prevProps.filters !== this.props.filters) {
      this.load();
    }
  }

  protected load() {
    this.searchOptions = {
      search: {
        ...this.props.filters,
        breed: {
          with: true,
        },
        specie: {
          with: true,
        },
        shelter: {
          with: {
            _fields: ["id", "uuid", "name"],
          },
        },
        mapping_specie: {
          with: true,
        },
      },
      options: {
        ...this.searchOptions.options,
        _force_ids: true,
        sort: ["-id"],
      },
    };

    this.props.loadMappingBreeds(this.searchOptions);

    if (this.props.onLoad) {
      this.props.onLoad(this.searchOptions);
    }
  }

  render() {
    const { loading, pagination, mappingBreeds, loadMappingBreeds } =
      this.props;

  

    return (
      <>
        <Table
          loading={loading}
          rowKey="uuid"
          columns={this.tableColumns}
          pagination={false}
          dataSource={mappingBreeds}
          onChange={(pagination: any, filters: any, sorter: any) =>
            this.handleTableChange(pagination, sorter, loadMappingBreeds)
          }
        />
        <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={mappingBreeds?.length}
          onChange={(pagination) =>
            this.handleTableChange(pagination, undefined, loadMappingBreeds)
          }
        />
      </>
    );
  }
}
